module.exports = "/images/ingredients-9.png";